<!-- app.component.html -->
<div class="bg-light">
  <!-- Navbar always on top -->
  <app-navbar></app-navbar>

  <!-- Sidebar + Content below navbar -->
  <div class="d-flex">
    <!-- Sidebar visible on md (≥768px) and up -->
    <app-sidebar class="d-none d-lg-block"></app-sidebar>

    <!-- Main content always visible -->
    <main class="container container-720 flex-grow-1 p-2">
      <div style="padding-top: 48px;">
<!--      <div class="main2">-->
        <router-outlet></router-outlet>
      </div>
<!--      </div>-->
    </main>
  </div>
</div>
